





































import {Component, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import DialogFooter from '@/components/DialogFooter.vue'

const biz = namespace('biz')
const auth = namespace('auth')
const userAgent = namespace('userAgent')

@Component({
  components: {DialogFooter}
})
export default class RequestNewTokenModal extends Vue {
  @biz.Action('refreshMatchToken') refreshMatchToken: (token: string) => Promise<void>
  @auth.State('matchToken') matchToken: string
  @auth.Action('signOut') signOut
  @userAgent.Getter('isMobile') isMobile: boolean

  showExpiredMatchToken: boolean = false
  showReconnectModal: boolean = false

  requestNewMatchToken() {
    this.refreshMatchToken(this.matchToken).then(() => {
      if(this.isMobile) {
        this.signOut()
        location.href='kakaoplus://plusfriend/talk/_Erxlxgj'
      } else {
        this.showReconnectModal = true
      }
    }).finally(() => {
      localStorage.removeItem('isMatchTokenValid')
      this.showExpiredMatchToken = false
    })
  }

  handleClose() {
    localStorage.removeItem('isMatchTokenValid')
    this.showExpiredMatchToken = false
  }

  handleConfirmReconnect() {
    this.showReconnectModal = false
    this.signOut()
  }

  mounted() {
    const isMatchTokenValid = localStorage.getItem('isMatchTokenValid')
    this.showExpiredMatchToken = isMatchTokenValid === null ? false : isMatchTokenValid === 'false'
  }
}
